<template>
  <div class="membership-detail app-page">
    <div class="detail-container">
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>加载中...</p>
      </div>

      <div v-if="error" class="error-message">{{ error }}</div>

      <div v-if="memberInfo && !loading" class="member-card">
        <div class="member-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
          <div class="status-badge" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
            <span class="status-dot"></span>
            {{ memberInfo.status === 1 ? '会员生效中' : '非会员' }}
          </div>

          <div v-if="memberInfo.status === 1" class="expire-info">
            <div class="expire-item">
              <span class="expire-label">会员类型</span>
              <span class="expire-value">{{ memberInfo.membershipTypeName }}</span>
            </div>
            <div class="expire-item">
              <span class="expire-label">有效期至</span>
              <span class="expire-value">{{ formatDate(memberInfo.endTime) }}</span>
            </div>
            <div class="expire-item">
              <span class="expire-label">剩余天数</span>
              <span class="expire-value highlight">{{ memberInfo.remainingDays }} 天</span>
            </div>
          </div>

          <div v-else class="non-member">
            <p>您当前不是会员，开通会员即可享受更多特权</p>
          </div>
        </div>

        <div class="member-benefits">
          <h2 class="benefits-title">会员权益</h2>
          <div class="benefits-grid">
            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/></svg>
              </div>
              <div class="benefit-info">
                <h3>无限发起匹配</h3>
                <p>非会员每日限3次匹配，会员无限制</p>
                <div class="benefit-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
                  {{ memberInfo.status === 1 ? '已解锁' : '未解锁' }}
                </div>
              </div>
            </div>

            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <div class="benefit-info">
                <h3>无限查看推荐好友</h3>
                <p>非会员每日限3次查看推荐，会员无限制</p>
                <div class="benefit-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
                  {{ memberInfo.status === 1 ? '已解锁' : '未解锁' }}
                </div>
              </div>
            </div>

            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
              </div>
              <div class="benefit-info">
                <h3>无限制聊天</h3>
                <p>非会员限3个新聊天对象，会员无限制</p>
                <div class="benefit-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
                  {{ memberInfo.status === 1 ? '已解锁' : '未解锁' }}
                </div>
              </div>
            </div>

            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              </div>
              <div class="benefit-info">
                <h3>专属会员标识</h3>
                <p>个人主页显示尊贵会员标识</p>
                <div class="benefit-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
                  {{ memberInfo.status === 1 ? '已解锁' : '未解锁' }}
                </div>
              </div>
            </div>

            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
              <div class="benefit-info">
                <h3>优先匹配</h3>
                <p>匹配队列中优先展示，提高曝光率</p>
                <div class="benefit-status" :class="memberInfo.status === 1 ? 'active' : 'inactive'">
                  {{ memberInfo.status === 1 ? '已解锁' : '未解锁' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="member-actions">
          <button class="action-btn primary" @click="$router.push('/membership/plans')">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            {{ memberInfo.status === 1 ? '续费会员' : '开通会员' }}
          </button>
          <button class="action-btn secondary" @click="showOrderHistory = true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            查看订单历史
          </button>
        </div>
      </div>
    </div>

    <!-- 订单历史弹窗 -->
    <el-dialog
      title="会员订单历史"
      v-model="showOrderHistory"
      width="70%"
      max-width="800px"
      :modal="true"
      class="order-dialog"
    >
      <div class="order-history">
        <div v-if="loadingOrders" class="loading">
          <div class="spinner small"></div>
          <p>加载订单中...</p>
        </div>

        <div v-if="orders.length === 0 && !loadingOrders" class="no-orders">
          暂无会员订单记录
        </div>

        <el-table
          v-if="orders.length > 0 && !loadingOrders"
          :data="orders"
          style="width: 100%"
          class="order-table"
        >
          <el-table-column
            prop="orderNo"
            label="订单编号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="membershipTypeName"
            label="会员类型"
          ></el-table-column>


          <el-table-column
            prop="amount"
            label="金额"
            :formatter="formatPrice"
          ></el-table-column>
          <el-table-column
            prop="statusName"
            label="状态"
            :formatter="formatStatus"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="formatDateTime"
          ></el-table-column>
          <el-table-column
            prop="payTime"
            label="支付时间"
            :formatter="formatDateTime"
          ></el-table-column>
  <el-table-column
    label="操作"
    width="120"
  >
    <template #default="scope">
      <!-- 仅对未支付状态(0)显示支付按钮 -->
      <el-button
        v-if="scope.row.status === 0"
        type="text"
        size="small"
        class="pay-btn"
        @click="handleGoToPay(scope.row.orderNo)"
      >
        去支付
      </el-button>
    </template>
  </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>


<script setup>
import { ref, onMounted, watch } from 'vue';
import membershipApi from '@/api/membership';
import { useRouter } from 'vue-router';
// 在 MembershipDetail.vue 的 script 部分
import { ElDialog, ElTable, ElTableColumn,ElMessage } from 'element-plus'
import 'element-plus/es/components/dialog/style/css'
// 已有的表格样式导入
import 'element-plus/es/components/table/style/css'
import 'element-plus/es/components/table-column/style/css'



const router = useRouter();
const memberInfo = ref(null);
const orders = ref([]);
const loading = ref(true);
const loadingOrders = ref(false);
const error = ref('');
const showOrderHistory = ref(false);
const currentUserId = ref(localStorage.getItem('userId') ? Number(localStorage.getItem('userId')) : null);


// 在 script 部分添加格式化函数
const formatPrice = (row) => {
  return `¥${row.amount}`;
};

// 跳转到支付页面
const handleGoToPay = (orderNo) => {
  // 关闭订单历史弹窗
  showOrderHistory.value = false;
  // 跳转到支付页面并携带订单号参数
  router.push({
    path: '/membership/pay',
    query: { orderNo }
  });
};

const formatStatus = (row) => {
  const statusMap = {
    0: '未支付',
    1: '已支付',
    2: '已取消'
  };
  return statusMap[row.status] || '未知状态';
};

// 格式化日期
const formatDateTime = (row, column) => {
  const value = row[column.property];
  if (!value) return '-';
  const date = new Date(value);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};


const fetchMembershipDetail = async () => {
  if (!currentUserId.value) {
    ElMessage.error('请先登录');
    router.push('/login');
    return;
  }

  try {
    loading.value = true;
    const res = await membershipApi.getMembershipDetail(currentUserId.value);

    if (res.data.code == 200) {
      memberInfo.value = res.data.data;
    } else {
      error.value = res.data.msg || '获取会员详情失败';
    }
  } catch (err) {
    error.value = err.response?.data?.msg || '获取会员详情失败';
  } finally {
    loading.value = false;
  }
};

const fetchOrderHistory = async () => {
  if (!currentUserId.value) return;

  try {
    loadingOrders.value = true;
    const res = await membershipApi.getMembershipOrders(currentUserId.value);

    if (res.data.code == 200) {
      orders.value = res.data.data || [];
    } else {
      ElMessage.error(res.data.msg || '获取订单历史失败');
      // 错误时保持弹窗显示
      // showOrderHistory.value = true;
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.msg || '获取订单历史失败');
    // 错误时保持弹窗显示
    // showOrderHistory.value = true;
  } finally {
    loadingOrders.value = false;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN');
};



// 监听订单历史弹窗显示
watch(showOrderHistory, (newVal) => {
  if (newVal) {
    fetchOrderHistory();
  }
});

onMounted(() => {
  fetchMembershipDetail();
});
</script>

<style scoped>

.detail-container {
  width: 100%;
}

.loading {
  text-align: center;
  padding: 60px 0;
}

.loading p {
  margin-top: 16px;
  color: var(--app-text-secondary);
  font-size: 0.9375rem;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border: 3px solid var(--app-border-light);
  border-top-color: var(--app-color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.spinner.small {
  width: 22px;
  height: 22px;
  border-width: 2px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.08);
  padding: 14px 20px;
  border-radius: var(--app-radius-md);
  text-align: center;
  margin-bottom: 1rem;
  border: 1px solid rgba(231, 76, 60, 0.15);
}

.member-card {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  overflow: hidden;
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
}

.member-status {
  padding: 32px 28px;
  text-align: center;
  position: relative;
}

.member-status.active {
  background: var(--app-gradient-primary);
  color: #fff;
}

.member-status.inactive {
  background: var(--app-gradient-secondary);
  color: #fff;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border-radius: var(--app-radius-full);
  font-size: 1.0625rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.status-badge.active {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
}

.status-badge.inactive {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2ecc71;
  display: inline-block;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.expire-info {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}

.expire-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.expire-label {
  font-size: 0.8125rem;
  opacity: 0.8;
}

.expire-value {
  font-size: 1.125rem;
  font-weight: 600;
}

.expire-value.highlight {
  background: rgba(255, 215, 0, 0.25);
  padding: 2px 12px;
  border-radius: var(--app-radius-full);
  color: #FFD93D;
}

.non-member {
  font-size: 1rem;
  line-height: 1.6;
  opacity: 0.9;
}

.member-benefits {
  padding: 28px;
}

.benefits-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--app-border-light);
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.benefit-card {
  display: flex;
  gap: 16px;
  background: var(--app-bg-soft);
  border-radius: var(--app-radius-lg);
  padding: 18px;
  border: 1px solid var(--app-border-subtle);
  transition: all 0.25s ease;
}

.benefit-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--app-shadow-card-hover);
  border-color: rgba(255, 126, 126, 0.2);
}

.benefit-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: var(--app-radius-md);
  background: var(--app-gradient-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.benefit-info {
  flex: 1;
  min-width: 0;
}

.benefit-info h3 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 4px;
}

.benefit-info p {
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
  margin: 0 0 8px;
  line-height: 1.5;
}

.benefit-status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: var(--app-radius-full);
  font-size: 0.75rem;
  font-weight: 500;
}

.benefit-status.active {
  background: rgba(46, 204, 113, 0.12);
  color: #27ae60;
}

.benefit-status.inactive {
  background: rgba(139, 124, 247, 0.1);
  color: #8B7CF7;
}

.member-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px 28px 28px;
  flex-wrap: wrap;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: var(--app-radius-lg);
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  border: none;
}

.action-btn.primary {
  background: var(--app-gradient-primary);
  color: #fff;
  box-shadow: 0 4px 15px rgba(255, 126, 126, 0.35);
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.45);
}

.action-btn.secondary {
  background: var(--app-bg-elevated);
  color: var(--app-text-primary);
  border: 1px solid var(--app-border-light);
}

.action-btn.secondary:hover {
  border-color: var(--app-color-primary);
  color: var(--app-color-primary);
  background: var(--app-color-primary-soft);
}

/* Dialog styles */
:deep(.order-dialog .el-dialog__header) {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--app-border-light);
}

:deep(.order-dialog .el-dialog__title) {
  font-size: 1.125rem;
  font-weight: 600;
}

:deep(.order-dialog .el-dialog__body) {
  padding: 20px 24px;
  background: var(--app-bg-soft);
  border-radius: 0 0 var(--app-radius-xl) var(--app-radius-xl);
}

.order-history {
  max-height: 420px;
  overflow-y: auto;
}

.order-table {
  border-radius: var(--app-radius-md);
  overflow: hidden;
}

:deep(.order-table .el-table__header th) {
  background: var(--app-bg-soft) !important;
  color: var(--app-text-secondary);
  font-weight: 600;
}

.no-orders {
  text-align: center;
  padding: 60px 20px;
  color: var(--app-text-muted);
  font-size: 0.9375rem;
}

.pay-btn {
  color: var(--app-color-primary) !important;
  font-weight: 500;
}

.pay-btn:hover {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .expire-info {
    flex-direction: column;
    gap: 16px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .member-actions {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
  }

  .member-benefits {
    padding: 20px 16px;
  }

  .member-actions {
    padding: 16px;
  }
}
</style>
